import { useTranslationInterface } from 'utils/hooks/useTranslation';

// strings for this module are in src/services/i18n/en-us/dataFeeds.json

export const useTranslations = () => useTranslationInterface('dataFeeds');
